import { ILoanLine } from 'gen/ApiClient';
import { IHandoverLine } from '../IHandoverLine';

export const loanLineToLine = (t: ILoanLine, line: IHandoverLine): IHandoverLine => {
	return {
		...line,
		id: t.id,
		description: t.description ?? line?.description ?? '',
		quantity: t.quantity,
		unitListPrice: t.unitListPriceInVat,
		unitPrice: t.unitPriceInVat,
	};
};
